import React from "react";
import Button from "../../../pageComponents/Settings/Free/Button";
import Grid from "@material-ui/core/Grid";
import Comma from "../../../../assets/images/comma.png";
import WoodInput from "../../../../assets/images/wood_frame.png";
// import backgroundImage from "../../../../background.jpg";

class WoodenInput extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            input:props.data.value
        }
    }
    handleSubmit=()=>{
        const input=this.state.input
        const inputMaxLength=this.props.data.inputMaxLength
        if (inputMaxLength==input.length)
            this.props.input(input)
    }
    handleChange=(e)=>{
        const {onlyInt}=this.props.data
        const re = /^[0-9\b]+$/;
        if (onlyInt && re.test(e.target.value))
            this.setState({input: e.target.value},this.handleSubmit);
        else if (!onlyInt)
            this.setState({input: e.target.value},this.handleSubmit);

    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.data.reset){
            if (this.state.input!=='')
            this.setState({
                input:''
            })
        }
    }

    render() {
        const {inputTextSize,inputMaxLength,color,backgroundColor,layerRadius,placeHolder,holderImage} = this.props.data

        return (
            <Grid  className='wooden-input' alignItems={"center"} justify={'center'} sm={12} item container>
                <img className='wooden-input-background-image' src={!holderImage?WoodInput:holderImage} alt=""/>
                <Grid className='wooden-input-background-layer' style={{backgroundColor:backgroundColor,borderRadius:layerRadius}}/>
                <input onChange={this.handleChange} value={this.state.input}  type="text" style={{fontSize:inputTextSize,color:color}} maxLength={inputMaxLength} placeholder={!placeHolder?'-----':placeHolder}/>
            </Grid>
        )
    }
}
export default WoodenInput